export enum DELIVERED {
  PENDING = 1,
  "PART DELIVERED",
  "FULL DELIVERED",
  "CLOSED BY ADMIN"
}